export const PROD_URL = "https://farm-app-test.herokuapp.com";
export const DEV_URL = "http://127.0.0.1:8000";
